import { useProximaSDK } from 'hooks';
import { useAdAccountStore, useBrandStore } from 'stores';
import { IntegrationType } from 'types/integrations';
import type { AdAccount } from 'types/stores/ad-account-store';

const useTiktok = () => {
  const adAccountStore = useAdAccountStore();
  const { brand } = useBrandStore();
  const tiktokIntegrationApi = useProximaSDK('TiktokIntegrationApi');

  const retrieveTiktokAdAccountFromApi = async (brandId: string) => {
    try {
      const response = await tiktokIntegrationApi.getTiktokAdAccounts(
        { brandId },
        { skipErrorToaster: true }
      );

      if (response.status !== 200) {
        return null;
      }

      const adAccounts = (response.data || []) as AdAccount[];

      adAccountStore.updateAdAcountsList(adAccounts, IntegrationType.TikTok);

      const activeAdAccount = adAccounts.find(adAccount => adAccount.status === 'active');

      return activeAdAccount ?? null;
    } catch {
      return null;
    }
  };

  const getTiktokAdAccount = async (opts?: { refresh?: boolean; brandId: string }) => {
    const { refresh = false, brandId = brand.brandId } = opts ?? {};

    if (refresh) adAccountStore.clear(IntegrationType.TikTok);
    else {
      const currentActiveAdAccount = adAccountStore.getActiveAdAccountFromList(
        IntegrationType.TikTok
      );

      if (currentActiveAdAccount) return currentActiveAdAccount;
    }
    const activeAdAccount = await retrieveTiktokAdAccountFromApi(brandId);

    if (activeAdAccount) adAccountStore.updateAdAccount(activeAdAccount, IntegrationType.TikTok);

    return activeAdAccount;
  };

  return {
    getTiktokAdAccount
  };
};

export default useTiktok;
